export default __webpack_public_path__ + "static/media/tool_item_blue3.0a524723.png";